import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService } from '../../shared';
import { InventoryTransactionLineContainerModel } from '../../../../../../models/aggregates/erp/inventory-transaction';
import { Core2Config } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class InventoryTransactionLineService extends BaseApiTemplateService<InventoryTransactionLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-line';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-line';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'inventory-transactions-line';
    this.httpClient = http;
  }

  public createAdjustment(containerList: InventoryTransactionLineContainerModel [], visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/adjustment/backoffice-ep';
    return this.httpClient.post(url, containerList, this.getHttpHeader(visa));
  }
}


